// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__3Qsbh","ScrollX":"Scroll_ScrollX__2vfvx","ScrollY":"Scroll_ScrollY__2tqww"};